import _objectSpread from "/root/workspace/ubq-h5_build/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'TabBar',
  props: {
    defaultActive: {
      type: Number,
      default: 0
    },
    isOriginFromBrand: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    skinChange: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      active: this.defaultActive
    };
  },
  watch: {
    defaultActive: function defaultActive(n) {
      this.active = n;
    }
  },
  methods: {
    handleSetTabBarIcon: function handleSetTabBarIcon(data, index) {
      var activeIcon = data.activeIcon,
          icon = data.icon; // 二级品牌馆icon需要切换icon

      return this.active === index ? activeIcon : icon;
    },
    handleChange: function handleChange(value) {
      var to = this.data[value].to;
      this.$emit('change', value);

      if (to.name === 'SearchResult') {
        // 生态馆缓存问题
        sessionStorage.setItem('refresh', 'true');
      } // 二级品牌馆tab切换只需要读取配置文件的路由参数


      this.$router.push(_objectSpread({}, to));
    }
  }
};